import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'zijin-screen',
  template: `
    <p>
      screen works!
    </p>
  `,
  styles: []
})
export class ScreenComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
